<template>
  <el-dialog :title="title" :visible="true" :before-close="handleClose" width="650px">
    <p class="margin-bottom">
      <span>{{ $t('16439') }}：</span>
      <span>{{ type }}</span>
    </p>
    <el-table :data="gridData">
      <!-- 加班日期 -->
      <el-table-column property="date_at" :label="$t('17010')"></el-table-column>
      <!-- 开始时间 -->
      <el-table-column property="start_time" :label="$t('1101')"></el-table-column>
      <!-- 结束时间 -->
      <el-table-column property="end_time" :label="$t('1102')"></el-table-column>
      <!-- 加班时长 -->
      <el-table-column property="duration" :label="$t('1711')"></el-table-column>
      <!-- 有效加班时长 -->
      <el-table-column property="effective_duration" :label="$t('1712')"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { attendanceOvertimeDetail } from 'api/Attendance'

export default {
  props: {},
  data() {
    return {
      title: '', // 标题
      gridData: [], // 表格数据
      type: '' // 加班类型文案
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 加班详情
    handlerGetData(msg) {
      this.title = this.$t('1641', { x: msg.staff_name })
      attendanceOvertimeDetail(msg).then(({ data }) => {
        this.gridData = data.list
        this.type = data.type
      })
    }
  }
}
</script>

<style></style>
